import React from 'react';
import MainContainer from '../components/layout/MainContainer';
import { TopbarBackgroundStyle } from '../components/layout/EnhancedModernTopbar';
import NewHomepage from '../components/pages/NewHome';
import { useAppState } from '@/context/AppStateContext';

const HomeContainer: React.FC = () => {
  const { appName } = useAppState();
  const title = `ระบบจัดการแม่พิมพ์ - ${appName}`;

  return (
    <MainContainer 
      title={title} 
      topbarBackgroundStyle={TopbarBackgroundStyle.BLUE_GRADIENT}
    >
      <NewHomepage />
    </MainContainer>
  );
};

export default HomeContainer;
